import moment from 'moment-timezone';

import { fetchWithHandling } from '@src/utils/fetching';
import OAuthResource from '@src/services/Identity/OAuthResource';

export async function onCreateTrial(accountId: string, userId: string) {
  const isAccountCreated = await fetchWithHandling(
    () => OAuthResource.createTrialAccount({ accountId, userId }),
    undefined,
    undefined,
    'Failed to create a Trial Account!',
  );
  if (isAccountCreated) {
    window.location.reload();
  }
}

export function isExpired(validTo: Date) {
  return moment.utc().isAfter(moment.utc(validTo));
}
